import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function ConsentCheckboxes({ consent, onChange, idPrefix = "consent" }) {
  const settings = useSiteSettings();
  const version = settings.privacy_policy_version || "1.0";

  return (
    <div className="space-y-3" data-testid={`${idPrefix}-group`}>
      <label className="flex items-start gap-2.5 text-sm text-slate-600 cursor-pointer">
        <input
          type="checkbox"
          required
          checked={consent.accept_policy}
          onChange={(e) => onChange({ ...consent, accept_policy: e.target.checked })}
          data-testid={`${idPrefix}-policy`}
          className="mt-0.5 w-4 h-4 accent-[#0072C6] shrink-0"
        />
        <span>
          Li e aceito a{" "}
          <a href="/privacidade" target="_blank" rel="noopener noreferrer" className="text-[#0072C6] underline">
            Política de Privacidade
          </a>
          . Autorizo o tratamento dos meus dados pessoais para a finalidade indicada. *
        </span>
      </label>
      <label className="flex items-start gap-2.5 text-sm text-slate-600 cursor-pointer">
        <input
          type="checkbox"
          checked={consent.accept_marketing}
          onChange={(e) => onChange({ ...consent, accept_marketing: e.target.checked })}
          data-testid={`${idPrefix}-marketing`}
          className="mt-0.5 w-4 h-4 accent-[#0072C6] shrink-0"
        />
        <span>
          Autorizo o contacto para fins de marketing e comunicações comerciais (opcional).
        </span>
      </label>
      <input type="hidden" data-testid={`${idPrefix}-version`} value={version} readOnly />
    </div>
  );
}
